import {LoaderFunctionArgs} from 'react-router-dom';
import {getETicket} from '../../redux/eTicket/eTicketActions';

export const ETICKET_TOKEN_LENGTH = 16;

export const eTicketLoader = async ({params}: LoaderFunctionArgs) => {
    const {token} = params;

    if(!token || token.length !== ETICKET_TOKEN_LENGTH) {
        return null;
    }

    await getETicket(token);
    return null;
};
